/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import { Region } from '../../model/Region';
import { RegionService } from '../../services/region.service';
import {BaseMessageComponent} from '../../common/base-message.component';

@Component({
    selector: 'app-regions',
    templateUrl: './regions.component.html',
    styleUrls: ['./regions.style.css'],
    standalone: false
})
export class RegionsComponent extends BaseMessageComponent implements OnInit {
  regions: Region[];
  indexWithChanges: number[] = [];

  constructor(private regionService: RegionService,
              private spinnerService: NgxSpinnerService,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    this.getRegions();
  }

  getRegions(): void {
    this.spinnerService.show();
    this.regions = [];
    this.indexWithChanges = [];
    this.regionService.getAll().subscribe( value => {
      this.regions = value;
      this.cdr.detectChanges();
      },
      err => {
      console.log(err);
      alert(err);
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
    }
    );
  }

  addNew(name: string) {
    if (name.trim() == "") {
      alert("Please add a name before saving a new record.");
    } else {
      this.spinnerService.show();
      var region = new Region();
      region.regionName = name;

      this.regionService.addNew(region).subscribe(value => {
          //success
          this.regions = null;
          this.getRegions();
        }, (error) => {
          //failed
          console.error(error);
          if (error.status=='409')
            alert("Duplicate Value(s) found.");
          else
            alert(error.message);
          this.spinnerService.hide();
        },
        () => {
          this.spinnerService.hide();
        });
    }
  }

  updateRegionsIndexes(index) {
    if(this.indexWithChanges.indexOf(index)===-1){
      this.indexWithChanges.push(index);
    }
    console.log(this.indexWithChanges);
  }

  saveChanges() {
    if(this.indexWithChanges.length > 0) {
      for (var i = 0; i < this.indexWithChanges.length; i++) {
        var idx = this.indexWithChanges[i];
        this.regionService.update(this.regions[idx]).subscribe(value => {
            console.log(this.regions[idx] + " saved.")
          }, (error) => {
            //failed
            console.error(error);
            if (error.status=='409')
              alert("Duplicate Value(s) found.");
            else
              alert(error.message);
          },
          () => {
            this.indexWithChanges = [];
          });
      }
      setTimeout(() => {
        this.getRegions();
      }, 4000);
    } else {
      alert("No changes to save.");
    }
  }
}
